module.exports = __webpack_public_path__ + "img/preparation.4e7d478f.svg";